import { registerS4StorageTreeExtension } from './tableMenuItems';
import { registerS4TableToolbarExtensions } from './tableToolbarExtensions';

let registered = false;
/** The one S4 registration line of `storage-explorer/index.ts`: toolbar entries + tree extension on S2's registries. */
export function registerS4StorageExtensions(): void {
  if (registered) return;
  registered = true;
  registerS4TableToolbarExtensions();
  registerS4StorageTreeExtension();
}
